import { render } from "./EditVM.vue?vue&type=template&id=0b7cea79&scoped=true"
import script from "./EditVM.vue?vue&type=script&lang=js"
export * from "./EditVM.vue?vue&type=script&lang=js"

import "./EditVM.vue?vue&type=style&index=0&id=0b7cea79&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7cea79"]])

export default __exports__